export default __webpack_public_path__ + "static/media/invoice.ef3a6dcd.svg";